export default __webpack_public_path__ + "static/media/avatar-s-3.c1d416e5.jpg";